// ----------------------------------------------------------------------
// <copyright file="Izenda.ActionBarActions.js" company="Izenda">
// Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var pure = require('recompose').pure;
  var withHandlers = require('recompose').withHandlers;
  var localization = require('share/localization/Izenda.Localizer');
  const { curry } = require('lodash/fp');

  var actionBarActions = compose(
    pure,
    withHandlers({
      onSave: curry(onSave),
      onCancel: curry(onCancel),
      onAddMapping: curry(onAddMapping)
    })
  );

  /**
   * Handle on save database mapping.
   * @param {Object} props
   * @param {Object} e
   */
  function onSave(props, e) {
    var valManager = props.validation;
    var loader = props.loader;
    var store = props.store;

    if (!store.databaseMappingDetail.checkDirty()) {
      store.setAlertDetail('success', localization.getText('COMMON_MESSAGES_NO_CHANGES_FOUND'));
      return;
    }

    store.databaseMappingDetail.resetMessage();

    valManager
      .validate()
      .then(function(success) {
        if (success) {
          return store.saveDataMapping();
        }
      })
      .finally(loader.endLoading.bind(loader));
  }

  /**
   * Handle on cancel database mapping.
   * @param {Object} props
   * @param {Object} e
   */
  function onCancel(props, e) {
    var store = props.store;
    var confirmFn = props.confirmFn;
    handleErrorValidation(props);

    if (store.databaseMappingDetail.checkDirty()) {
      confirmFn('Confirmation', {
        description: localization.getText('COMMON_MESSAGES_CONFIRM_CANCEL')
      }).then(function() {
        store.loadDataMapping();
      });
    }
  }

  /**
   * Add mapping handler.
   * @param {Object} props
   * @param {Object} e
   */
  function onAddMapping(props, e) {
    handleErrorValidation(props);
    props.store.addMapping();
  }

  /**
   * Handle error validations when user makes an action.
   * @param {Object} props
   */
  function handleErrorValidation(props) {
    props.validation.reset();
  }

  module.exports = actionBarActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DatabaseMapping/ActionBar/Izenda.ActionBarActions.js